import React, { useState, useEffect, useRef } from 'react'
import AanLogo from '../assets/img/logo.png';
import { FaPlaneDeparture } from 'react-icons/fa';
import { FaPlaneArrival } from 'react-icons/fa';
import { logos } from '../data/AirlineLogo';
import AirplaneLogo from '../assets/img/plane.png'
import AutoScroll from '../components/scroll/AutoScroll';
import Header from '../components/header/Header';
import Horloge from '../components/horloge/Holorge';
import Footer from '../components/footer/Footer';
import './ArrDep.css'


// --Getting the api from the backend(Data)
// Departure
const apiUrlDep = 'https://ataflight.atalou.com/src/data/Mtpp/allArrivals.php';
// Arrivals
const apiUrlArr = 'https://ataflight.atalou.com/src/data/Mtpp/allDepartures.php';


function ArrDep() {


	const tbodyArrRef = useRef(null);

	const [currentTime, setCurrentTime] = React.useState(new Date());
	const [arrivalsData, setArrivalsData] = useState([]);
	const [departuresData, setDeparturesData] = useState([]);

	React.useEffect(() => {
		const timer = setInterval(() => {
			setCurrentTime(new Date());
		}, 1000);
		return () => clearInterval(timer);
	}, []);


	// --Departure
	const fetchDataDep = async () => {
		try {
			const response = await fetch(apiUrlDep)
			if (!response.ok) {
				throw new Error("An error as occured while fetching the Departures")
			}
			let data = await response.json()
			setDeparturesData(data[0] || [])
		} catch (e) {
			console.log("An error has been catched", e)
		}
	}


	// --Arrivals


	const fetchDataArr = async () => {
		try {
			const response = await fetch(apiUrlArr)
			if (!response.ok) {
				throw new Error("An error as occured while fetching the Arrivals")
			}
			let data = await response.json()
			console.log("here are the data", data)
			setArrivalsData(data[0] || [])
		} catch (e) {
			console.log("An error has been catched", e)
		}
	}

	useEffect(() => {
		import('bootstrap/dist/css/bootstrap.min.css');

		fetchDataDep();
		fetchDataArr();

		// --- Refresh data every 30s ---
		const refreshInterval = setInterval(() => {
			fetchDataDep();
			fetchDataArr();
		}, 30000);

		// --- Auto-scroll logic for arrivals ---
		let scrollInterval;
		const setupScroll = () => {
			if (!tbodyArrRef.current) return;
			const tbody = tbodyArrRef.current;
			const rowHeight = tbody.querySelector("tr")?.offsetHeight || 0;
			let scrollPos = 0;
			const totalHeight = tbody.scrollHeight - tbody.offsetHeight;

			scrollInterval = setInterval(() => {
				if (scrollPos >= totalHeight) {
					scrollPos = 0; // reset to top
				} else {
					scrollPos += rowHeight; // scroll one row
				}
				tbody.scrollTo({
					top: scrollPos,
					behavior: "smooth",
				});
			}, 2000); // scroll every 2 seconds
		};

		setupScroll();

		return () => {
			clearInterval(refreshInterval);
			clearInterval(scrollInterval);
		};
	}, []);


	return (
		<div
			className="container-fluid containerDiv"
		>
			<div className="row g-1 FirstschildDiv">
				{/* --DEPARTURE PART */}
				<div className="col-6 d-flex align-items-stretch "  style={{ height: "100%" }}>
					<div className="card w-100 d-flex flex-column "  style={{ height: "100%" }}>
						<div className='header-grid-split'>
							<header>
								<div className="logo">
									<img src={AanLogo} alt="Logo" />
									<div>
										<div className='logo-label'>Aéroport International</div>
										<div className='logo-label'>Cap-Haitien</div>
									</div>
								</div>
								<div className="departures">
									<h1>Departures< FaPlaneDeparture /></h1>
								</div>
								<div className="current-time">
									<h1><Horloge /></h1>
								</div>
							</header>
							<div className="flight-header">
								<div className='item'>Airline</div>
								<div className='item'>Flight</div>
								<div className='item'>to</div>
								<div className='item'>Time</div>
								<div className='item'>Status</div>
							</div>
						</div>
						<div
							className="mt-4"
							style={{
								backgroundColor: "#1F3249",
							}}
						>
							<div className="flex-fill" style={{ width: "100%" }}>
								<AutoScroll
									data={departuresData}
									loading={departuresData.length === 0}
									typeVol="DEPARTURES"
								/>
							</div>
						</div>
					</div>
				</div>


				{/* --ARRIVALS PART */}
				<div className="col-6 d-flex align-items-stretch" style={{ height: "100%" }}>
					<div className="card w-100 d-flex flex-column" style={{ height: "100%" }}>
						<div className='header-grid-split'>
							<header>
								<div className="logo">
									<img src={AanLogo} alt="Logo" />
									<div>
										<div className='logo-label'>Aéroport International</div>
										<div className='logo-label'>Cap-Haitien</div>
									</div>
								</div>
								<div className="arrivals">
									<h1>Arrivals < FaPlaneArrival /></h1>
								</div>
								<div className="current-time">
									<h1><Horloge /></h1>
								</div>
							</header>
							<div className="flight-header">
								<div className='item'>Airline</div>
								<div className='item'>Flight</div>
								<div className='item'>to</div>
								<div className='item'>Time</div>
								<div className='item'>Status</div>
							</div>
						</div>
						<div
							className="mt-4"
							style={{
								backgroundColor: "#1F3249",
							}}
						>
							<div className="flex-fill" style={{ width: "100%" }}>
								<AutoScroll
									data={arrivalsData}
									loading={arrivalsData.length === 0}
									typeVol="ARRIVALS"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			< Footer />
		</div>

	)
}

export default ArrDep